module.exports = __webpack_public_path__ + "static/LCScriptTT-Regular-eef317c08fb8e86b091d8ae5968c4d7b.ttf";